/* Harbor Funnel — interactive behaviors */
(function () {
  'use strict';

  // ----- Gallery -----
  function initGallery() {
    var gallery = document.querySelector('[data-gallery]');
    if (!gallery) return;
    var slides = gallery.querySelectorAll('.funnel-gallery__slide');
    var thumbs = gallery.querySelectorAll('.funnel-gallery__thumb');
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var idx = parseInt(t.dataset.thumbIndex, 10);
        slides.forEach(function (s, i) { s.classList.toggle('is-active', i === idx); });
        thumbs.forEach(function (tt, i) { tt.classList.toggle('is-active', i === idx); });
      });
    });
  }

  // ----- Variant pills -----
  function initVariants() {
    var pills = document.querySelectorAll('.funnel-variant');
    if (!pills.length) return;
    var hiddenInput = document.querySelector('[data-variant-input]');
    var stickyInput = document.querySelector('[data-sticky-variant-input]');
    var atcPrice = document.querySelector('[data-atc-price]');
    var stickyPrice = document.querySelector('[data-sticky-price]');

    pills.forEach(function (pill) {
      pill.addEventListener('click', function (e) {
        // Allow clicking anywhere on pill
        var id = pill.dataset.variantId;
        var priceCents = parseInt(pill.dataset.variantPrice, 10);
        pills.forEach(function (p) { p.classList.remove('is-selected'); });
        pill.classList.add('is-selected');
        var radio = pill.querySelector('input[type=radio]');
        if (radio) radio.checked = true;
        if (hiddenInput) hiddenInput.value = id;
        if (stickyInput) stickyInput.value = id;
        if (window.funnelVariantMedia && typeof window.funnelVariantMedia[id] === 'number') {
          var slideIdx = window.funnelVariantMedia[id];
          if (slideIdx >= 0) {
            var slides = document.querySelectorAll('.funnel-gallery__slide');
            var thumbs = document.querySelectorAll('.funnel-gallery__thumb');
            slides.forEach(function (s, i) { s.classList.toggle('is-active', i === slideIdx); });
            thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === slideIdx); });
          }
        }
        var formatted = formatMoney(priceCents);
        if (atcPrice) atcPrice.textContent = formatted;
        if (stickyPrice) stickyPrice.textContent = formatted;
        // Update URL ?variant= for shareability without reload
        if (window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', id);
          window.history.replaceState({}, '', url);
        }
      });
    });
  }

  function formatMoney(cents) {
    var dollars = (cents / 100).toFixed(2);
    return '$' + dollars + ' USD';
  }

  // ----- Countdown to midnight (or to 4pm shipping cutoff) -----
  function initCountdown() {
    var el = document.querySelector('[data-countdown]');
    if (!el) return;
    function tick() {
      var now = new Date();
      // 4pm local cutoff
      var cutoff = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 16, 0, 0);
      if (now > cutoff) {
        cutoff.setDate(cutoff.getDate() + 1);
      }
      var diff = cutoff - now;
      var hrs = Math.floor(diff / 3600000);
      var mins = Math.floor((diff % 3600000) / 60000);
      el.textContent = hrs + 'h ' + (mins < 10 ? '0' + mins : mins) + 'm';
    }
    tick();
    setInterval(tick, 30000);
  }

  // ----- Sticky ATC visibility -----
  function initSticky() {
    var sticky = document.querySelector('[data-sticky-atc]');
    var hero = document.querySelector('.funnel-hero');
    if (!sticky || !hero) return;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        sticky.classList.toggle('is-visible', !entry.isIntersecting);
      });
    }, { threshold: 0, rootMargin: '-200px 0px 0px 0px' });
    observer.observe(hero);
  }

  function init() {
    initGallery();
    initVariants();
    initCountdown();
    initSticky();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
